import React from "react";
import * as Form from "@radix-ui/react-form";
import { FieldMessage, FormField, Input } from "../Styles";

export default function EmailInput({
  label,
  name,
  register,
  errors,
  readOnly = false,
}) {
  return (
    <FormField name={name}>
      <Form.Label>{label}</Form.Label>
      <Form.Control asChild>
        <Input
          type="email"
          {...register(name, {
            required: "Email is required",
            disabled: readOnly,
            pattern: {
              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
              message: "Invalid email address",
            },
          })}
        />
      </Form.Control>
      {errors[name] && (
        <FieldMessage type="error">{errors[name].message}</FieldMessage>
      )}
    </FormField>
  );
}
